import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useImpersonation } from '../contexts/ImpersonationContext';

interface RegularUserRouteGuardProps {
  children: ReactNode;
}

const RegularUserRouteGuard = ({ children }: RegularUserRouteGuardProps) => {
  const { user, isLoading } = useAuth();
  const { isImpersonating } = useImpersonation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.isMegaAdmin && !isImpersonating) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default RegularUserRouteGuard;
